module.exports = __webpack_public_path__ + "assets/img/detail-img3-2e2c9c93.png";